/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2021-08-11 14:48:11
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-02-09 14:52:09
 */
const ajax = function (url,id) {
    const loading = this.$loading({
        lock: true,
        text: '正在加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    var ss = null
    this.$.ajax({
        url:this.requestUrl + url,
        type: 'POST', // 默认为GET
        dataType: 'json',
        async: false,
        // xhrFields:{
        //     withCredentials:true
        // },
        // crossDomain:true,
        data: {
            timestamp: this.timestamp,
            random: this.numRandom,
            sign: this.mainSign,
            id:id
        },
        timeout: 5000,
        success: function (result) {
            // console.log(result);
            ss = result;
            loading.close();
          
        },
        error: function () {
            console.log('错误')
            
        }
    })
    return ss
}

export default ajax